import { Box } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { MainMap } from "../../MainMap";
import { MapControls } from "../../MapControls";
import { MapLegend } from "../../overlay/MapLegend";

const MiniMapBase: React.FC = () => {
  return (
    <Box height="400px" width="100%" position="relative">
      <MainMap reducedMapSize />
      <MapControls hideQueryPolygon={true} />
      <MapLegend />
    </Box>
  );
};

export const MiniMap = observer(MiniMapBase);
